'use strict';
import {stateGo} from 'redux-ui-router';

OrgInviteWizard.$inject = [
  '$ngRedux',
  '$state',
];

export function OrgInviteWizard(
  $ngRedux,
  $state,
) {

  let manager = null;
  let recoveryState = null;
  // var states = {
  //  start: {
  //    state: {
  //      name: 'invitation-login',
  //      params: ['accessCode']
  //    },
  //    actions: {
  //      login: {
  //        next: {
  //          name: 'invitation_confirmation'
  //        }
  //      },
  //      signup: {
  //        next: {
  //          name: 'create_profile'
  //        }
  //      }
  //    }
  //  },
  //  create_profile: {},
  //  invitation_confirmation: {},
  //  complete: {}
  // };

  this.start = start;
  this.getResumePoint = getResumePoint;
  this.performAction = performAction;

  function start(wManager) {
    manager = wManager;

    // TODO(redux): Test out retrieving from redux store directly
    const accessCode = manager.$$getState('accessCode') || $state.params.accessCode;

    if (!accessCode) {
      manager.destroy();
      $ngRedux.dispatch(stateGo('login'));
    } else {
      manager.$$update({
        accessCode: accessCode,
      });

      recoveryState = {name: 'invitation-login', params: {accessCode: accessCode}};
    }
  }

  function resume(_manager) {
    manager = _manager;
  }

  /**
   * Return the state information needed to resume if the app is restarted
   * @param {string} actionName
   * @param {object} [actionParams=null]
   * @returns {{name: string, params: {object}}}
   */
  function getResumePoint(actionName, actionParams) {
    return recoveryState;
  }

  function performAction(actionName, actionParams) {
    switch (actionName) {
      case 'login':

        break;
      case 'signup':

        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/auth/wizards/OrgInviteWizard.js